"use strict";
import { createContext, useContext } from "react";
const TDPContext = createContext(void 0);
export function useTDPContext() {
  const context = useContext(TDPContext);
  if (!context) {
    throw new Error("useTDPContext must be used within a TDPContextProvider");
  }
  return context;
}
export function TDPProvider({ children, contextValue }) {
  return <TDPContext.Provider value={contextValue}>{children}</TDPContext.Provider>;
}
